import { AxiosError } from 'axios';
import { baseService } from 'services';
import {
  ITokens,
  ILoginBody,
  ILoginVerificationBody,
} from 'interface/apiInterface';
import {
  commonError,
  loginEP,
  loginVerifyEP,
  refreshTokenEP,
} from 'services/constants';
import { store } from 'redux-setup/store';
import {
  setEmail,
  setOnboarding,
  setToken,
} from 'redux-setup/slices/userSlice';
import { clearPagePermission } from 'redux-setup/slices/permissionSlice';
import { clearColumnDetails } from 'redux-setup/slices/ColumnFilterSlice';
import { setOrganization } from 'redux-setup/slices/organizationSlice';

export const login = async (body: ILoginBody) => {
  try {
    const response = await baseService.post(loginEP, body);
    return response;
  } catch (error) {
    return commonError(error as AxiosError);
  }
};

export const loginVerification = async (body: ILoginVerificationBody) => {
  try {
    const response = await baseService.post(loginVerifyEP, body);
    return response;
  } catch (error) {
    return commonError(error as AxiosError);
  }
};

export const refreshAccessToken = async (RefreshToken: string) => {
  try {
    const response = await baseService.post(refreshTokenEP, { RefreshToken });
    return response;
  } catch (error) {
    logOut();
    return commonError(error as AxiosError);
  }
};

export const setTokensInStorage = (tokens: ITokens) => {
  if (tokens.RefreshToken) {
    localStorage.setItem('refresh_token', tokens.RefreshToken);
  }
  if (tokens.AccessToken) {
    localStorage.setItem('access_token', tokens.AccessToken);
  }
};

export const logOut = () => {
  store.dispatch(clearPagePermission());
  store.dispatch(clearColumnDetails());
  store.dispatch(setToken(''));
  store.dispatch(setEmail(''));
  store.dispatch(setOrganization({}));
  store.dispatch(setOnboarding(false));
  setTokensInStorage({ RefreshToken: '', AccessToken: '' });
  window.parent.postMessage({ logout: true }, '*');
  localStorage.removeItem('github_login_state');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('access_token');
  localStorage.removeItem('invite_user_url');
  localStorage.removeItem('github_installation_state');
  window.parent.postMessage({ logout: true }, '*');
};
